import { render, staticRenderFns } from "./TransferCallModal.vue?vue&type=template&id=20f76c59&"
import script from "./TransferCallModal.vue?vue&type=script&lang=js&"
export * from "./TransferCallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports